import createTableStore from "ds/components/Table/store/useTableStore";

import { SPACE_USERS_COLUMN_CONFIG, SPACE_USERS_COLUMNS_STORAGE_KEY } from "./constants";

const useSpaceDetailsUsersTableStore = createTableStore({
  storageKey: SPACE_USERS_COLUMNS_STORAGE_KEY,
  config: SPACE_USERS_COLUMN_CONFIG,
});

export default useSpaceDetailsUsersTableStore;
